import React, { ChangeEventHandler, useEffect } from 'react';
import { useRouter } from 'next/router';
import { getAsPath } from 'react-scale/lib/utils';

type Props = {
  onSelectChange: ChangeEventHandler<HTMLSelectElement>;
  value: string;
};

export const DateSelect = ({ onSelectChange, value }: Props) => {
  const router = useRouter();

  useEffect(() => {
    router.push(
      getAsPath(router.asPath, { pastEvents: value === 'past' ? 'true' : 'false' }),
      undefined,
      {
        scroll: false
      }
    );
  }, [value]);

  return (
    <select
      value={value}
      onChange={onSelectChange}
      name="date-picker"
      id="date-select"
      className="px-4 py-3 flex w-full lg:w-fit border-none min-w-[132px] rounded-[100px] bg-white text-black cursor-pointer font-bold font-unicode"
      aria-label="Filter by date"
    >
      <option value="past">Past</option>
      <option value="upcoming">Upcoming</option>
    </select>
  );
};
